<template>
  <body>
    <h3 class="title">{{ t('policy_info') }}</h3>

    <div class="wrapper-paragraph">
      <p class="accent">· 대표자</p>
      <p>공정일</p>
    </div>
    <div class="wrapper-paragraph">
      <p class="accent">· E-mail</p>
      <p>connect@sconai.com</p>
    </div>
    <div class="wrapper-paragraph">
      <p class="accent">· 통신판매신고</p>
      <p>통신판매신고 제2025-인천부평-1947호</p>
    </div>
    <div class="wrapper-paragraph">
      <p class="accent">· 주소</p>
      <p>
        본점 : 인천광역시 부평구 충선로 209번길 41 <br />
        서울지사: 서울특별시 영등포구 영등포로 150
      </p>
    </div>
  </body>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.section-title {
  margin: 1.5rem 0 0.5rem 0;
}

.wrapper-paragraph {
  margin: 0 0 1rem 1.5rem;

  .small {
    margin: 0 0 0 1.5rem;
  }
}
</style>
